module.exports = __webpack_public_path__ + "img/if_6.0761f714.png";